const prepareShow = graduations => {
  return graduations
}
export default {
  prepareShow
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/resources/methods.js